import { h } from 'preact';

import isNotEmptyArray from '@travel/ui/utils/arrays';

import LinkAccordion from 'components/LinkAccordion';

import styles from './hotelFooter.module.scss';

import type { linkProps } from 'Common-Types';
type Props = {
  links: Array<linkProps>;
  hotelName: string;
};

const HotelFooter = (props: Props) => {
  const { links, hotelName } = props;

  return (
    <div className={styles.planList}>
      <div className={styles.itemList}>
        <p className={styles.hotelName}>{hotelName}</p>
        <div>
          {isNotEmptyArray(links) &&
            links.map(link => <LinkAccordion linkData={link} key={link.name} />)}
        </div>
      </div>
    </div>
  );
};

export default HotelFooter;
